import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  fetchEQPaynetSearchReport({ state }, { eqPaynetReportData } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.equifaxPaynetReport.fetchEQPaynetSearchReport
        }`,
        eqPaynetReportData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  orderEquifaxPaynetReport({ state }, { eqPaynetReportData } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.equifaxPaynetReport.orderEquifaxPaynetReport
        }`,
        eqPaynetReportData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
